import { render, staticRenderFns } from "./AMAfaBlade.vue?vue&type=template&id=a439987e&scoped=true"
import script from "./AMAfaBlade.vue?vue&type=script&lang=ts"
export * from "./AMAfaBlade.vue?vue&type=script&lang=ts"
import style0 from "./AMAfaBlade.vue?vue&type=style&index=0&id=a439987e&prod&lang=scss&scoped=true"
import style1 from "./AMAfaBlade.vue?vue&type=style&index=1&id=a439987e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a439987e",
  null
  
)

export default component.exports